import { Link } from "@/lib/router-compat";
import { Home } from "lucide-react";
import SEO from "@/components/SEO";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";

const LegacyGone = () => (
  <div className="min-h-dvh bg-background flex flex-col font-sans">
    <SEO
      title="Page No Longer Available"
      description="This page was part of a previous version of our website and has been permanently removed."
      robots="noindex, nofollow"
    />
    <Navigation />
    <main className="flex-grow flex items-center justify-center min-h-[60vh]">
      <div className="container-max px-6 py-20 text-center max-w-2xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
          Page No Longer Available
        </h1>
        <p className="text-lg text-muted-foreground mb-8">
          This page was part of a previous version of our website and has been permanently removed. Please use the navigation above to find what you need.
        </p>
        <Button asChild size="lg" className="btn-hero">
          <Link to="/">
            <Home className="mr-2 h-5 w-5" />
            Return Home
          </Link>
        </Button>
      </div>
    </main>
    <Footer />
  </div>
);

export default LegacyGone;
